import { Helmet } from 'react-helmet-async';
import BillingClient from '../components/billing/BillingClient';

export default function BillingPage() {
  return (
    <>
      <Helmet>
        <title>Billing - Doctif</title>
        <meta name="description" content="Practice billing and payment management" />
      </Helmet>
      
      <div className="p-6 md:p-8">
        <BillingClient />
      </div>
    </>
  );
}
